const IMG = {
  "general-contracting": "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHxfHxob3VzZSUyMGZyYW1pbmclMjBjb25zdHJ1Y3Rpb24lMjByZW5vdmF0aW9ufGVufDB8fHx8MTc5MzczNDE0Nnww&ixlib=rb-4.1.0&q=85",
  "roofing-hvac": "https://images.unsplash.com/photo-1754620906703-496ec2451744?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxyb29mZXIlMjB3b3JraW5nJTIwb24lMjByb29mJTIwSFZBQyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3OTM3MzQxNDZ8MA&ixlib=rb-4.1.0&q=85",
  "junk-removal": "https://images.unsplash.com/photo-1781425009053-2baffa997d8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxqdW5rJTIwaGF1bGluZyUyMHRydWNrJTIwdHJhc2glMjBkaXNwb3NhbCUyMGxvYWRpbmd8ZW58MHx8fHwxNzkzNzM0MTUzfDA&ixlib=rb-4.1.0&q=85",
  "pressure-washing": "https://images.unsplash.com/photo-1677956787377-a0f32c0974af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBzcHJheSUyMGNsZWFuaW5nJTIwd2F0ZXIlMjB3b3JrZXJ8ZW58MHx8fHwxNzkzNzM0MTUzfDA&ixlib=rb-4.1.0&q=85",
  "landscaping": "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHxffGxhbmRzY2FwaW5nJTIwZ2FyZGVuJTIwbGF3biUyMG1vd2VyJTIwZ2FyZGVuZXIlMjB0cmltbWluZ3xlbnwwfHx8fDE3OTM3MzQxNDZ8MA&ixlib=rb-4.1.0&q=85",
  "plumbing": "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHxffHBsdW1iZXIlMjBwaXBlcyUyMHJlcGFpciUyMHdyZW5jaHxlbnwwfHx8fDE3OTM3MzQxNTN8MA&ixlib=rb-4.1.0&q=85",
  "painting": "https://images.unsplash.com/photo-1562259949-e8e7689d7828?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHxffHBhaW50ZXIlMjBwYWludGluZyUyMHdhbGwlMjByb2xsZXIlMjBwYWludCUyMHNwcmF5fGVufDB8fHx8MTc5MzczNDE0Nnww&ixlib=rb-4.1.0&q=85",
  "electrical": "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2lhbiUyMHBhbmVsJTIwd2lyaW5nJTIwcmVwYWlyfGVufDB8fHx8MTc5MzczOTI0Mnww&ixlib=rb-4.1.0&q=85",
  "concrete": "https://images.unsplash.com/photo-1574757987642-5755f0839101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxjb25jcmV0ZSUyMHBvdXJpbmclMjBmaW5pc2hpbmclMjB3b3JrZXJ8ZW58MHx8fHwxNzkzNzM5MjM5fDA&ixlib=rb-4.1.0&q=85",
  "tree-service": "https://images.pexels.com/photos/34674271/pexels-photo-34674271.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TRADE_DEMOS = {
  "general-contracting": {
    slug: "general-contracting",
    trade: "General Contracting",
    demoBusiness: "Summit Build Co.",
    accent: "#D4AF37",
    hero: "Win bigger bids before you ever step on site.",
    sub: "A website that presents your crew, your craftsmanship, and your past projects like the general contractor clients trust with six-figure builds.",
    image: IMG["general-contracting"],
    painPoints: [
      "Losing bids to contractors with a more professional online presence",
      "Tire-kicker calls that waste your estimator's time",
      "No place to show project photos that actually impress",
    ],
    features: [
      "Project gallery organized by build type and budget range",
      "Quote intake form that pre-qualifies budget, timeline, and scope",
      "Crew and license/credential pages that build instant trust",
      "Service-area pages for every city you work in",
    ],
    packages: {
      starter: "3-page presence site — Home, Projects, Contact",
      growth: "5-page lead machine — gallery, quote funnel, local SEO",
      premium: "10-page market leader — portfolio stories, service areas, FAQ",
    },
    services: ["Custom Builds", "Renovations", "Additions"],
  },
  "roofing-hvac": {
    slug: "roofing-hvac",
    trade: "Roofing & HVAC",
    demoBusiness: "Apex Roofing & Air",
    accent: "#7FB3D5",
    hero: "Own the emergency search before the storm hits.",
    sub: "When a roof leaks or an AC dies, homeowners call the first pro they trust. We make sure that's you.",
    image: IMG["roofing-hvac"],
    painPoints: [
      "Competitors capturing emergency and storm-season searches",
      "Price shoppers with no sense of your quality or speed",
      "Seasonal feast-or-famine lead flow",
    ],
    features: [
      "Emergency-repair CTA with tap-to-call on every page",
      "Financing and estimate calculator that warms up cold leads",
      "Zip-code service pages that rank for 'near me' searches",
      "Review integration that puts your 5-stars front and center",
    ],
    packages: {
      starter: "3-page presence site — Services, Reviews, Contact",
      growth: "5-page lead machine — emergency CTAs, financing calc, SEO",
      premium: "10-page market leader — zip pages, maintenance plans, FAQ",
    },
    services: ["Roof Repair", "AC Install", "Emergency Service"],
  },
  "junk-removal": {
    slug: "junk-removal",
    trade: "Junk Removal",
    demoBusiness: "HaulAway Pros",
    accent: "#8FBC8F",
    hero: "Turn 'how much to haul this?' into booked jobs.",
    sub: "Customers want a price and a pickup window, fast. A site built for junk removal closes them before they call your competitor.",
    image: IMG["junk-removal"],
    painPoints: [
      "Endless 'how much for a couch?' calls that don't convert",
      "Customers booking with whoever answers first",
      "No way to show the volume of jobs you actually handle",
    ],
    features: [
      "Photo-upload quote form — customers snap it, you price it",
      "Instant booking slots so jobs land on your schedule directly",
      "Before/after gallery that shows real truckloads cleared",
      "Pricing guide page that filters out time-wasters",
    ],
    packages: {
      starter: "3-page presence site — Services, Pricing, Contact",
      growth: "5-page lead machine — photo quotes, booking, local SEO",
      premium: "10-page market leader — suburbs pages, commercial, FAQ",
    },
    services: ["Furniture Removal", "Estate Cleanouts", "Debris Hauling"],
  },
  "pressure-washing": {
    slug: "pressure-washing",
    trade: "Pressure Washing",
    demoBusiness: "Clearline Wash Co.",
    accent: "#5FB4C9",
    hero: "Before-and-after proof that sells itself.",
    sub: "Nothing converts like a filthy driveway turned spotless. We build the gallery and instant-quote engine around exactly that.",
    image: IMG["pressure-washing"],
    painPoints: [
      "Amazing results nobody sees beyond your yard signs",
      "Quotes that die in text-message threads",
      "One-off jobs instead of recurring seasonal contracts",
    ],
    features: [
      "Before/after slider gallery that does the selling for you",
      "Surface-picker instant quote — driveway, deck, siding, roof",
      "Seasonal maintenance plan signup for recurring revenue",
      "Neighborhood pages that rank where your customers live",
    ],
    packages: {
      starter: "3-page presence site — Services, Gallery, Contact",
      growth: "5-page lead machine — instant quote, gallery engine, SEO",
      premium: "10-page market leader — plans, neighborhoods, FAQ",
    },
    services: ["Driveways", "House Washing", "Decks & Patios"],
  },
  "landscaping": {
    slug: "landscaping",
    trade: "Landscaping",
    demoBusiness: "Evergreen Outdoor Co.",
    accent: "#9DC88D",
    hero: "Fill your route with clients who value the craft.",
    sub: "Homeowners choosing a landscaper buy with their eyes. A portfolio of your best lawns and builds turns lookers into seasonal contracts.",
    image: IMG["landscaping"],
    painPoints: [
      "Competing on price with every guy with a mower",
      "Beautiful installs that only the neighbors ever see",
      "One-time jobs instead of weekly maintenance contracts",
    ],
    features: [
      "Seasonal portfolio gallery — lawns, hardscapes, planting beds",
      "Maintenance plan page that sells weekly and monthly routes",
      "Instant estimate form with yard size and service picker",
      "Neighborhood-targeted pages for the areas you want",
    ],
    packages: {
      starter: "3-page presence site — Services, Gallery, Contact",
      growth: "5-page lead machine — estimate form, plans, local SEO",
      premium: "10-page market leader — design showcase, neighborhoods, FAQ",
    },
    services: ["Weekly Lawn Care", "Landscape Design", "Hardscaping"],
  },
  "plumbing": {
    slug: "plumbing",
    trade: "Plumbing",
    demoBusiness: "ClearFlow Plumbing",
    accent: "#6FA8DC",
    hero: "Be the first call when the pipe bursts.",
    sub: "Plumbing customers search in a panic and hire in minutes. A fast, trust-first site with one-tap calling wins that moment.",
    image: IMG["plumbing"],
    painPoints: [
      "Emergency calls going to whoever ranks first on Google",
      "Customers who can't tell a master plumber from a handyman",
      "Review platforms owning your reputation instead of you",
    ],
    features: [
      "Emergency banner with tap-to-call that follows the scroll",
      "License, insurance, and guarantee badges above the fold",
      "Service pages for drains, water heaters, repipes, and more",
      "Review wall that pulls your best ratings onto your own turf",
    ],
    packages: {
      starter: "3-page presence site — Services, Reviews, Contact",
      growth: "5-page lead machine — emergency CTA, service pages, SEO",
      premium: "10-page market leader — repipe/commercial pages, FAQ, financing",
    },
    services: ["Emergency Repairs", "Water Heaters", "Drain Cleaning"],
  },
  "painting": {
    slug: "painting",
    trade: "Painting",
    demoBusiness: "TrueTone Painters",
    accent: "#E8A87C",
    hero: "A portfolio as flawless as your finish work.",
    sub: "Painting is the most visual trade there is. A color-rich gallery and instant estimate form turn browsers into booked estimates.",
    image: IMG["painting"],
    painPoints: [
      "Competing with uninsured budget painters on price alone",
      "No gallery that shows the quality of your prep and finish",
      "Estimate requests scattered across texts and voicemails",
    ],
    features: [
      "Color-rich project gallery — interiors, exteriors, cabinets",
      "Room-picker estimate form with square-foot pricing logic",
      "Before/after transformations that justify premium rates",
      "Reviews and warranty page that separates you from cheap bids",
    ],
    packages: {
      starter: "3-page presence site — Services, Gallery, Contact",
      growth: "5-page lead machine — estimate form, transformations, SEO",
      premium: "10-page market leader — color consults, commercial, FAQ",
    },
    services: ["Interior Painting", "Exterior Painting", "Cabinet Refinishing"],
  },
  "electrical": {
    slug: "electrical",
    trade: "Electrical",
    demoBusiness: "Brightline Electric",
    accent: "#F0C75E",
    hero: "Power up the calls that keep your crews booked.",
    sub: "Homeowners hiring an electrician want licensed, safe, and fast. Your site proves all three before they ever pick up the phone.",
    image: IMG["electrical"],
    painPoints: [
      "Losing panel upgrades and rewires to bigger shops with slicker sites",
      "Customers who can't tell a licensed electrician from a handyman",
      "Emergency calls going to whoever shows up first on Google",
    ],
    features: [
      "License and insurance badges front and center on every page",
      "Emergency-service banner with one-tap calling",
      "Service pages for panels, EV chargers, lighting, and rewires",
      "Estimate form that captures job type, photos, and urgency",
    ],
    packages: {
      starter: "3-page presence site — Services, Reviews, Contact",
      growth: "5-page lead machine — emergency CTA, estimate form, SEO",
      premium: "10-page market leader — EV/commercial pages, financing, FAQ",
    },
    services: ["Panel Upgrades", "EV Chargers", "Lighting & Rewires"],
  },
  "concrete": {
    slug: "concrete",
    trade: "Concrete",
    demoBusiness: "SolidForm Concrete",
    accent: "#B8B0A4",
    hero: "Show the finish. Book the pour.",
    sub: "Driveways, patios, and stamped work sell on photos. A gallery-first site turns your best pours into a steady stream of estimate requests.",
    image: IMG["concrete"],
    painPoints: [
      "Beautiful stamped patios that only exist on your camera roll",
      "Competing against low-bid crews with no way to show the difference",
      "Estimate requests scattered across calls, texts, and DMs",
    ],
    features: [
      "Project gallery by job type — driveways, patios, stamped, foundations",
      "Estimate form with square footage and finish options",
      "Before/after transformations that justify premium work",
      "Service-area pages for every suburb you pour in",
    ],
    packages: {
      starter: "3-page presence site — Services, Gallery, Contact",
      growth: "5-page lead machine — estimate form, gallery, local SEO",
      premium: "10-page market leader — commercial work, neighborhoods, FAQ",
    },
    services: ["Driveways", "Stamped Patios", "Foundations"],
  },
  "tree-service": {
    slug: "tree-service",
    trade: "Tree Service",
    demoBusiness: "Canopy & Crown Tree Care",
    accent: "#7BAE7F",
    hero: "Be the crew they call when the tree comes down.",
    sub: "Storm damage and dangerous limbs are urgent, emotional searches. A trust-first site with instant calling wins the job in minutes.",
    image: IMG["tree-service"],
    painPoints: [
      "Storm-season emergencies going to whoever answers first",
      "Customers nervous about uninsured climbers near their roof",
      "Big removal jobs lost because your expertise isn't visible online",
    ],
    features: [
      "Emergency storm-damage CTA with tap-to-call on every page",
      "Insurance and certified-arborist credentials above the fold",
      "Photo estimate form — customers snap the tree, you price it",
      "Service pages for removal, trimming, stump grinding, and storm cleanup",
    ],
    packages: {
      starter: "3-page presence site — Services, Reviews, Contact",
      growth: "5-page lead machine — emergency CTA, photo estimates, SEO",
      premium: "10-page market leader — storm pages, service areas, FAQ",
    },
    services: ["Tree Removal", "Trimming & Pruning", "Stump Grinding"],
  },
};

export const TRADE_ORDER = ["general-contracting", "roofing-hvac", "junk-removal", "pressure-washing", "landscaping", "plumbing", "painting", "electrical", "concrete", "tree-service"];

